import { lazyGettext } from '@eb/lazy-gettext';
import {
    BASIC_TICKETING,
    DIGITAL_TICKETS,
    FAST_CHECKIN,
    INTEGRATIONS_A,
    MOBILE_OPTIMIZED,
    MULTIPLE_EVENTS,
    ONE_TICKET_TYPE,
    ONLINE_HELP_CENTER,
    ORGANIZER_MOBILE_APP,
    PARTNER_SITES,
    PROMOTIONAL_TOOLS,
    REPORTING_ESSENTIALS,
    SALES_TRACKING,
    SECURE_PAYMENTS,
    SIMPLE_CHECKOUT,
} from '../../constants/features';
import {
    CRESCENT_CITY_CLASSIC,
    WEB_DIRECTIONS,
    YMCA,
} from '../../constants/testimonials';
import {
    DEFAULT_PACKAGES,
    FINE_PRINT_WITH_FIXED_FEE,
    PACKAGE_ONE,
    PER_PAID_TICKET_TEXT,
} from '../../constants/main';
import { STYLE_FILL, STYLE_NEUTRAL } from '@eb/eds-button';

export default {
    mainHeader: {
        tabs: DEFAULT_PACKAGES,
        currentIndex: 0,
        imagePath: `${PACKAGE_ONE}/essentials-hero-graphic`,
        bgImgHeight: 425,
        heading: lazyGettext('Essentials'),
        secondaryHeading: lazyGettext(
            'Easy-to-use event technology for any budget.',
        ),
        perPaidTicketText: PER_PAID_TICKET_TEXT,
        priceDescription: lazyGettext('Free for free tickets'),
        primaryCTA: lazyGettext('Try Essentials'),
        CTAStyle: STYLE_FILL,
        dataAutomation: 'package-one-main-header',
        pricingCalloutText: lazyGettext('View fee breakdown.'),
        pricingCalloutDescriptionPrimary: lazyGettext(
            'Pass fees on to attendees, pay nothing.',
        ),
        pricingCalloutDescriptionSecondary: lazyGettext(
            'As always, no fees apply for free tickets.',
        ),
    },
    featureListOne: {
        heading: lazyGettext('Start selling in minutes'),
        secondaryHeading: lazyGettext(
            "No matter what event you're hosting, Eventbrite makes it easier than ever to set up an event page and start selling tickets or registrations.",
        ),
        features: [MOBILE_OPTIMIZED, SECURE_PAYMENTS, PROMOTIONAL_TOOLS],
        imagePaths: [
            `${PACKAGE_ONE}/brand--listing`,
            `${PACKAGE_ONE}/brand--checkout`,
            `${PACKAGE_ONE}/facebook`,
        ],
    },
    featureListTwo: {
        heading: lazyGettext(
            'Simplify your planning to set yourself up for success',
        ),
        features: [SALES_TRACKING, MULTIPLE_EVENTS, INTEGRATIONS_A],
        imagePath: `${PACKAGE_ONE}/brand--crowdrise`,
    },
    featureListThree: {
        heading: lazyGettext('Give your attendees a seamless experience'),
        features: [SIMPLE_CHECKOUT, DIGITAL_TICKETS, FAST_CHECKIN],
        imagePath: `${PACKAGE_ONE}/brand--ticket`,
    },
    testimonials: {
        heading: lazyGettext(
            'Events all over the world use Eventbrite to drive ticket sales',
        ),
        testimonials: [CRESCENT_CITY_CLASSIC, YMCA, WEB_DIRECTIONS],
    },
    featuresExpansion: {
        heading: lazyGettext('Features included with Essentials'),
        features: [
            BASIC_TICKETING,
            REPORTING_ESSENTIALS,
            PARTNER_SITES,
            ONE_TICKET_TYPE,
            ORGANIZER_MOBILE_APP,
            ONLINE_HELP_CENTER,
        ],
        processingFeesFinePrint: FINE_PRINT_WITH_FIXED_FEE,
    },
    upsellBanner: {
        heading: lazyGettext('Looking to grow your events?'),
        CTA: lazyGettext('Learn more'),
        CTAStyle: STYLE_FILL,
        secondaryHeading: lazyGettext('Check out Eventbrite Professional.'),
    },
    bottomBanner: {
        heading: lazyGettext('Use Eventbrite Essentials'),
        secondaryHeading: lazyGettext('to start selling in minutes'),
        CTA: lazyGettext('Try Essentials'),
        CTAStyle: STYLE_NEUTRAL,
    },
};
